<template>
  <h4 class="mt-4">
    {{ $t('configurator.headings.booth_draft_optional') }}
  </h4>
  <table class="table table-condensed table-sm">
    <thead>
      <tr>
        <th>{{ $t('configurator.tables.columns.file') }}</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr v-if="shoppingCart.booth_draft">
        <td>{{ shoppingCart.booth_draft.original_name }}</td>
        <td>
          <span class="text-primary cursor--pointer" @click="removeDraft">
            <i class="fa fa-trash"></i> {{ $t('configurator.buttons.delete') }}
          </span>
        </td>
      </tr>
      <tr v-else>
        <td colspan="2">
          <i>{{ $t('configurator.labels.no_booth_draft_uploaded') }}</i>
        </td>
      </tr>
    </tbody>
  </table>
  <div v-if="!shoppingCart.booth_draft" class="text-center mt-3">
    <button
      type="button"
      class="btn btn-primary"
      :disabled="disabled"
      @click="showUploadModal">
      {{ $t('configurator.buttons.upload_booth_draft') }}
    </button>
  </div>
  <upload-booth-draft-modal v-if="uploadModalActive" @close="hideUploadModal" @uploaded="onUploaded">
  </upload-booth-draft-modal>
</template>

<script setup>
import { computed, ref } from 'vue'
import { useMainStore } from '@/store'

const store = useMainStore()
// define props
const props = defineProps({
  disabled: {
    type: Boolean,
    default: false
  }
})
// define reactive props
const uploadModalActive = ref(false)
// define computed props
const shoppingCart = computed(() => store.settings.shopping_cart)
// define methods
const removeDraft = () => {
  shoppingCart.value.booth_draft = null
}

const showUploadModal = () => {
  uploadModalActive.value = true
}

const hideUploadModal = () => {
  uploadModalActive.value = false
}

const onUploaded = (file) => {
  shoppingCart.value.booth_draft = file
  hideUploadModal()
}
</script>